import React from 'react';

const AdminSettingsPage = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 pt-32 pb-10">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-[#2A2A2A]">Paramètres</h1>
        <p className="text-[#6B6B6B] mt-2">
          Configure les options principales du site et de la boutique.
        </p>
      </div>

      <div className="bg-white border border-[#E6E1D6] rounded-2xl p-6 shadow-sm space-y-6">
        <div>
          <label className="block text-sm font-medium text-[#2A2A2A] mb-2">
            Message d’annonce
          </label>
          <input
            type="text"
            placeholder="Ex: Livraison offerte ce week-end"
            className="w-full rounded-xl border border-[#E6E1D6] px-4 py-3 outline-none focus:ring-2 focus:ring-[#2A2A2A]"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-[#2A2A2A] mb-2">
            Frais de livraison
          </label>
          <input
            type="number"
            placeholder="0"
            className="w-full rounded-xl border border-[#E6E1D6] px-4 py-3 outline-none focus:ring-2 focus:ring-[#2A2A2A]"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-[#2A2A2A] mb-2">
            Email de contact boutique
          </label>
          <input
            type="email"
            placeholder="contact@legers-coffee.com"
            className="w-full rounded-xl border border-[#E6E1D6] px-4 py-3 outline-none focus:ring-2 focus:ring-[#2A2A2A]"
          />
        </div>

        <button className="px-5 py-3 rounded-xl bg-[#2A2A2A] text-white font-medium hover:opacity-90 transition">
          Enregistrer
        </button>
      </div>
    </div>
  );
};

export default AdminSettingsPage;